export const COMMUNITY_OFFER_PATHS = {
	all: '/community-offers',
	mine: '/community-offers/mine',
	responsesMine: '/community-offers/responses/mine',
	responsesByOffer: '/community-offers/:id/responses',
	new: '/community-offers/new',
	edit: '/community-offers/:id/edit',
	detail: '/community-offers/:id',
} as const;

export type CommunityOfferPath = typeof COMMUNITY_OFFER_PATHS[keyof typeof COMMUNITY_OFFER_PATHS];

export const getCommunityOfferDetailPath = (id: string): string =>
	`/community-offers/${encodeURIComponent(id)}`;

export const getCommunityOfferEditPath = (id: string): string =>
	`/community-offers/${encodeURIComponent(id)}/edit`;

export const getCommunityOfferResponsesPath = (id: string): string =>
	`/community-offers/${encodeURIComponent(id)}/responses`;

export const getActiveCommunityOfferPath = (
	pathname: string,
): CommunityOfferPath | undefined => {
	const normalizedPathname =
		pathname.length > 1 && pathname.endsWith('/')
			? pathname.slice(0, -1)
			: pathname;

	return (Object.values(COMMUNITY_OFFER_PATHS) as string[]).find(
		path => path === normalizedPathname,
	) as CommunityOfferPath | undefined;
};
